import React, { useEffect, useMemo, useState } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  BoxProps, useMediaQuery,
} from "@chakra-ui/react";

import APButton from "./APButton";
import {FormattedMessage, useIntl} from "react-intl";

function APCommonDialog({
  children,
  open,
  title,
  onNext,
  onClose,
  error,
  btnTitle,
  footer,
  footerJustifyContent,
  disableFooter
}: {
  children: any;
  open: boolean;
  title: string | React.ReactNode;
  onNext?: any;
  onClose: () => void;
  error: boolean;
  btnTitle?: string;
  footer?: React.ReactNode;
  footerJustifyContent?: BoxProps["justifyContent"];
  disableFooter?: boolean;
}) {
  const onContinue = () => {
    onNext();
  };
  const intl = useIntl();
  const [isLargeScreen] = useMediaQuery("(min-width: 764px)");

  const renderFooter = useMemo(() => {
    if (footer) {
      return footer;
    } else {
      if (error) {
        return (
          <Button
            variant={"solid"}
            sx={{
              bg: "#f95928",
              color: "white",
              boxShadow: "0px 4px 0 0 #d13100",
              border: "1px solid #f95928",
              "&:hover": {
                bg: "#fc7928",
              },
              padding: isLargeScreen ? "0px 44px" : "0px 35px",
              minHeight: isLargeScreen ? "56px" : "45px",
              fontSize: isLargeScreen ? "1.26rem" : "1rem"
            }}
            onClick={() => onContinue()}
          >
            <FormattedMessage id="quit-button" defaultMessage={"Quitter"}/>
          </Button>
        );
      } else {
        return (
          <Button
            variant={"solid"}
            sx={{
              bg: "cyan.550",
              color: "white",
              boxShadow: "0px 4px 0 0 #3398a4",
              border: "1px solid #51b6c2",
              "&:hover": {
                bg: "#6bc1cb",
              },
              padding: isLargeScreen ? "0px 44px" : "0px 35px",
              minHeight: isLargeScreen ? "56px" : "45px",
              fontSize: isLargeScreen ? "1.26rem" : "1rem"
            }}
            onClick={() => onContinue()}
          >
            {btnTitle ? btnTitle : intl.formatMessage({id: 'next-button', defaultMessage: "Suivant"})}
          </Button>
        );
      }
    }
  }, [footer, onContinue, btnTitle]);

  return (
    <>
      <Modal closeOnOverlayClick={false} isOpen={open} onClose={onClose}>
        <ModalOverlay>
          <ModalContent
            sx={{
              width: { base: "calc(100% - 48px)", md: "100%" },
              maxWidth: isLargeScreen ? "35rem" : "28rem",
              my: isLargeScreen ? "4.75rem" : "3.75rem"
            }}
          >
            <ModalHeader
              className="ap-dailog-header"
              sx={{
                textAlign: "center",
                p: isLargeScreen ? "1.9rem" : "1.5rem",
                fontSize: isLargeScreen ? "1.5rem" : "1.25rem"
              }}
            >
              {title}
            </ModalHeader>
            <ModalCloseButton
              size={isLargeScreen ? "lg" : undefined}
              sx={{w: isLargeScreen ? "60px" : "48px", h: isLargeScreen ? "60px" : "48px"}}
            />
            <ModalBody className="ap-dialog-body" sx={{fontSize: isLargeScreen ? "1.26rem" : "1rem"}}>
              {children}
            </ModalBody>

            {!disableFooter && (
              <ModalFooter
                sx={{
                  display: "flex",
                  justifyContent: footerJustifyContent
                    ? footerJustifyContent
                    : "center",
                  background: "#ebebeb",
                  borderRadius: "0px 0px 20px 20px",
                  p: isLargeScreen ? "1.9rem" : "1.5rem",
                }}
              >
                {renderFooter}
                {/* {hasSecondButton && (
                <Button
                  variant={"solid"}
                  sx={{
                    bg: "#fff",
                    color: "#000",
                    boxShadow: "0px 6px 0px #E7E1D8",
                    border: "1px solid #E7E1D8",
                    "&:hover": {
                      bg: "#F5F3EF",
                    },
                    "&:focus": {
                      boxShadow: "0px 6px 0px #E7E1D8 !important",
                    },
                    padding: "0px 35px",
                    minHeight: "45px",
                  }}
                  onClick={onClickSecondButton}
                >
                  {secondButtonlabel}
                </Button>
              )} */}
              </ModalFooter>
            )}
          </ModalContent>
        </ModalOverlay>
      </Modal>
    </>
  );
}

export default APCommonDialog;
